module.exports = "<p>glossary works!</p>\n"